import PropTypes from 'prop-types';
import React from 'react';

const DetailsTileField = ({ data }) => {
  const { title, values, icon, href } = data;

  const renderValues = values.map(value => (
    <div key={`${title}_${value}`} className="your-data-field-row__value">
      {value}
    </div>
  ));

  const field = (
    <div className="your-data-field-row">
      <div className="your-data-field-row__icon">
        <i className={icon} />
      </div>
      <div className="your-data-field-row__data">
        <div className="your-data-field-row__label">{title}</div>
        {renderValues}
      </div>
    </div>
  );

  return href ? <a href={href}>{field}</a> : field;
};

const DetailsTileFieldDataShape = PropTypes.shape({
  title: PropTypes.string,
  values: PropTypes.array,
  icon: PropTypes.string,
  href: PropTypes.string,
});

DetailsTileField.propTypes = {
  data: DetailsTileFieldDataShape,
};

export default DetailsTileField;
export { DetailsTileFieldDataShape };
